import { ISurveyOption } from './questions/common';

interface ISurveyAnswers {
  id: string;
  selection?: Array<{
    value?: string;
    details?: string;
  }>;
}
export const getDefaultValueSingle = (defaultValue?: ISurveyAnswers) => {
  if (defaultValue && defaultValue.selection && defaultValue.selection.length > 0 && defaultValue.selection[0].value) {
    return defaultValue.selection[0].value;
  }
  return null;
};

export const getDefaultValueMultiple = (defaultValue?: ISurveyAnswers) => {
  if (defaultValue && defaultValue.selection && defaultValue.selection.length > 0) {
    return defaultValue.selection.map((x) => x.value);
  }
  return [];
};

export const getDefaultValueMultipleDetails = (defaultValue?: ISurveyAnswers) => {
  try {
    if (defaultValue && defaultValue.selection && defaultValue.selection.length > 0) {
      const details = defaultValue.selection.filter((x) => !!x && !!x.details);
      if (!!details) {
        return details[0].details;
      }
      return '';
    }
  } catch (error) {}
  return '';
};

export const getDefaultValueFreeText = (defaultValue?: ISurveyAnswers) => {
  try {
    if (defaultValue && defaultValue.selection && defaultValue.selection.length > 0) {
      const details = defaultValue.selection.filter((x) => !!x && !!x.details);
      if (!!details) {
        return details[0].details;
      }
      return '';
    }
  } catch (error) {}
  return '';
};

export const getDefaultShowDetails = (defaultValue?: ISurveyAnswers, options?: Array<ISurveyOption>) => {
  if (defaultValue && defaultValue.selection && defaultValue.selection.length > 0) {
    for (let index = 0; index < defaultValue.selection.length; index++) {
      const element = defaultValue.selection[index];
      if (((options || []).find((x) => x.value === (element.value || '')) || {}).hasDetails) {
        return true;
      }
    }

    return false;
  }
  return false;
};
